export function getItem(key: string, useSessionStorage = false): Json | null {
    if (typeof window !== 'object') {
        return null
    }

    const value = useSessionStorage ? window.sessionStorage.getItem(key) : window.localStorage.getItem(key)

    return value != null ? JSON.parse(value) : null
}
